import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import moment from "moment";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";

import { uiBuildNumber } from "../../env";

// import css style
import "./footer.css";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifShowError: false,
      inputValue: "",
      open: false, // open material ui dialog
      defaultValue: "",
    };
  }
  componentDidMount() {
    if (!this.props.apiBuildNumber) {
      this.props.getAPIBuildNumber();
    }
  }
  handleEmailInput(e) {
    this.setState({
      inputValue: e.target.value,
      ifShowError: false,
      defaultValue: e.target.value,
    });
  }
  handleClick() {
    if (
      !/^(([^<>()\\]\\.,;:\s@"]+(\.[^<>()\\\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.state.inputValue,
      )
    ) {
      this.setState({
        ifShowError: true,
      });
    } else {
      this.setState({
        open: true,
      });
      // window.setTimeout(() => {
      //   this.setState({
      //     open: false,
      //     defaultValue: ''
      //   })
      // }, 5000)
    }
  }
  handleClose = () => {
    this.setState({
      open: false,
      defaultValue: "",
    });
  };
  render() {
    const { apiBuildNumber, client_info, roleId, selected_client } = this.props;

    const disableSegmentListLink =
      roleId > 3
        ? isEmpty(client_info) ||
          client_info.subscription.id > 3 ||
          roleId === 5
        : !(selected_client > 0);
    const disableSegmentCreateLink =
      isEmpty(client_info) || disableSegmentListLink;
    const curYear = moment().format("YYYY");
    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        onTouchTap={this.handleClose}
        style={{ background: "black" }}
        labelStyle={{ color: "white" }}
        hoverColor="black"
        backgroundColor="black"
      />,
    ];

    if (this.props.hideFooter === true) return null;
    if (
      (this.props.loginUserDetail && !this.props.loginUserDetail.baroUid) ||
      (this.props.optimizeUserDetail &&
        this.props.optimizeUserDetail.aaUser &&
        parseInt(
          this.props.optimizeUserDetail.aaUser.subscriptionTierId,
          10,
        ) !== 5)
    ) {
      return (
        <MuiThemeProvider>
          <footer className="acquire-footer">
            <div
              className="wrapper row"
              style={{ margin: 0, padding: "10px 0px" }}
            >
              <div className="col-xs-3 col-md-3 col-sm-3 col-lg-3 email">
                <img
                  alt=""
                  src="/images/claritas-logo.png"
                  style={{ display: "inline-table", height: "28px" }}
                />
                <div className="email mt-20">
                  <div className="row-1">
                    <span>E-mail: </span>
                    <a href="mailto:AudienceAnywhere@claritas.com">
                      AudienceAnywhere@claritas.com
                    </a>
                  </div>
                  <div className="row-2">
                    {/*
                        <span>Phone: </span>
                        <span>650-212-2233</span>*/}
                  </div>

                  {/*
                      <div className="row-3 clearfix">
                        <Email
                          style={{float: 'left', color: 'white', marginLeft: '-0.2em'}}
                        />
                        <span className="ml-10" style={{letterSpacing: "0.4px"}}>Sign up to receive updates on Audience Anywhere</span>
                      </div>
                      
                      <div className="row-4 clearfix">
                        <div className="input-wrapper">
                          <TextField
                            style={{width: '11em', height: '32px'}}
                            hintText="Enter your e-mail"
                            errorText={this.state.ifShowError ? 'incorrect email address' : ''}
                            onChange={(e, newValue) => this.handleEmailInput(e, newValue)}
                            hintStyle={{color: 'white', textAlign:'center', paddingLeft:'5px'}}
                            inputStyle={{color:'white', paddingLeft: '6px', top: "-5px"}}
                            underlineFocusStyle={{color:"#273246"}}
                            value={this.state.defaultValue}
                            errorStyle={{bottom: '-4px'}}
                          />
                          <button onClick={() => this.handleClick()} 
                            style={{bottom: this.state.ifShowError ? '1.2em' : '0em'}} className="bg-grey-300 text-blue-800" >GO</button>
                        </div>
      
                      </div>
                      */}
                  {/*<div className="row-5 clearfix">*/}
                  {/*<Download*/}
                  {/*style={{color: 'white', float: 'left', marginLeft: '-0.4em'}}*/}
                  {/*/>*/}
                  {/*<a href="">Download our brochure</a>*/}
                  {/*</div>*/}
                  <div className="row-5">
                    <a
                      href="https://www.facebook.com/acquireweb/"
                      target="_blank"
                    >
                      <i className="share facebook" />
                    </a>
                    <a href="https://twitter.com/AcquireWeb" target="_blank">
                      <i className="share twitter" />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/139383/"
                      target="_blank"
                    >
                      <i className="share linkedin" />
                    </a>

                    {/*<i className="share t"></i>*/}
                    <a
                      href="https://plus.google.com/108494344907614937182"
                      target="_blank"
                    >
                      <i className="share google-plus" />
                    </a>
                  </div>
                  <div className="row-6">
                    Copyright ©{curYear} Claritas, LLC.
                    <br /> All rights reserved.
                  </div>
                </div>
              </div>
              <div className="col-xs-3 col-md-3 col-sm-3 col-lg-3 services clearfix">
                <h2>Audience</h2>
                <div className="email">
                  <div className="row-1">
                    {disableSegmentListLink ? (
                      <span style={{ color: "#6c6c6c" }}>
                        My Audience Segments
                      </span>
                    ) : (
                      <Link to="/segments/list/active">
                        My Audience Segments{" "}
                      </Link>
                    )}
                  </div>
                  <div className="row-2">
                    {disableSegmentCreateLink ? (
                      <span style={{ color: "#6c6c6c" }}>
                        Create an <br />
                        Audience Segment
                      </span>
                    ) : (
                      <Link to="/segment/create">
                        Create an <br />
                        Audience Segment{" "}
                      </Link>
                    )}
                  </div>
                  <h2 style={{ marginTop: "20px", marginBottom: "10px" }}>
                    Insights
                  </h2>
                  <div style={{ fontSize: "16px", letterSpacing: "1px" }}>
                    {roleId === 5 ? (
                      <span style={{ color: "#6c6c6c" }}>
                        Insights and Analytics
                      </span>
                    ) : (
                      <a href={"/insights/summary?cid=" + selected_client}>
                        Insights and Analytics
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-2 col-md-2 col-sm-2 col-lg-2 quick-links clearfix">
                <h2>Quick Links</h2>
                <div className=" email">
                  <div className="row-1">
                    <a href="mailto:AudienceAnywhere@claritas.com">Support</a>
                  </div>
                  <div className="row-2 mb-10">
                    <a href="http://acquireweb.com/about-us" target="_blank">
                      About Us
                    </a>
                  </div>
                  <div className="row-6">
                    <a href="http://acquireweb.com/careers" target="_blank">
                      Careers
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xs-2 col-md-2 col-sm-2 col-lg-2 policies clearfix">
                <h2>Policies</h2>
                <div className="email">
                  <div className="row-1">
                    <a
                      href="https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf"
                      target="_blank"
                    >
                      Privacy Policy
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xs-3 col-md-3 col-sm-3 col-lg-3 emial reg clearfix">
                <div>
                  <span style={{ letterSpacing: "0.4px" }}>
                    Sign up to our newsletter/updates
                  </span>
                </div>
                {/*
                    <div className="row clearfix mt-20">
                      <div className="input-wrapper">
                        <form action="https://acquireweb.us14.list-manage.com/subscribe/post?u=d336fb8ecf2556001ac378ba5&id=4957a5c6bc" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
                          <input type="email" value={this.state.defaultValue} name="EMAIL" className="required email" id="mce-EMAIL"></input>
                          <div id="mce-responses" className="clear">
                            <div className="response" id="mce-error-response" style={{display: 'none'}}></div>
                            <div className="response" id="mce-success-response" style={{display: 'none'}}></div>
                          </div> 
                          <div style={{position: 'absolute', left: '-5000px'}}>
                            <input type="text" name="b_d336fb8ecf2556001ac378ba5_4957a5c6bc" tabIndex="-1" value="" />
                          </div>
                          <div className="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />
                          </div>
                        </form>
                      </div>
                    </div>*/}
                <div className="row-4 clearfix mt-20">
                  <div id="mc_embed_signup">
                    <form
                      action="https://acquireweb.us14.list-manage.com/subscribe/post?u=d336fb8ecf2556001ac378ba5&id=4957a5c6bc"
                      method="post"
                      id="mc-embedded-subscribe-form"
                      name="mc-embedded-subscribe-form"
                      className="validate"
                      target="_blank"
                      noValidate
                    >
                      <div id="mc_embed_signup_scroll">
                        <input
                          type="text"
                          value={this.state.defaultValue}
                          onChange={(e) => this.handleEmailInput(e)}
                          name="EMAIL"
                          className="email"
                          id="mce-EMAIL"
                          placeholder="email address"
                          required
                        />
                        <div style={{ position: "absolute", left: "-5000px" }}>
                          <input
                            type="text"
                            name="b_d336fb8ecf2556001ac378ba5_4957a5c6bc"
                            tabIndex="-1"
                            value=""
                          />
                        </div>
                        <div className="clear mt-20">
                          <input
                            type="submit"
                            value="Sign Up"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                            className="button btn-signup-email"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  {/*
                        <div className="input-wrapper">
                          <TextField
                            style={{ width: '180px', height: '30px', border: 'solid 1px' }}
                            errorText={this.state.ifShowError ? 'incorrect email address' : ''}
                            onChange={(e, newValue) => this.handleEmailInput(e, newValue)}
                            inputStyle={{ color: '#000', paddingLeft: '6px', background: "#FFF" }}
                            underlineShow={false}
                            value={this.state.defaultValue}
                            errorStyle={{ bottom: '-4px' }}
                          />
                        </div>*/}
                </div>
                {/*
                      <div className="mt-20">
                        <button onClick={() => this.handleClick()}
                          style={{ bottom: this.state.ifShowError ? '1.2em' : '0em' }} className="btn-signup-email" >SIGN UP</button>
                      </div>*/}
                <div className="copy-right">
                  {uiBuildNumber && apiBuildNumber && (
                    <span
                      className="pull-right text-right"
                      style={{ fontSize: "0.6em" }}
                    >
                      <small>UI Build #{uiBuildNumber}</small>
                      <br />
                      <small>API Build #{apiBuildNumber}</small>
                    </span>
                  )}
                </div>
              </div>
            </div>
            <Dialog
              actions={actions}
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose}
              actionsContainerStyle={{
                marginTop: "-2em",
                paddingBottom: "4em",
                paddingRight: "32.2em",
              }}
            >
              <p
                style={{
                  width: "16.1em",
                  textAlign: "center",
                  margin: "4em auto 4em",
                }}
              >
                Thanks for signing up to receive our e-newsletters!
              </p>
            </Dialog>
            <Dialog
              actions={actions}
              modal={false}
              open={this.state.open}
              onRequestClose={this.handleClose}
              actionsContainerStyle={{
                marginTop: "-2em",
                paddingBottom: "4em",
                paddingRight: "32.2em",
              }}
            >
              <p
                style={{
                  width: "16.1em",
                  textAlign: "center",
                  margin: "4em auto 4em",
                }}
              >
                Thanks for signing up to receive our e-newsletters!
              </p>
            </Dialog>
          </footer>
        </MuiThemeProvider>
      );
    }
    return null;
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx